var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSortDescending = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M70 200c5.523 0 10 4.477 10 10v30c0 5.523-4.477 10-10 10H30c-5.523 0-10-4.477-10-10v-30c0-5.523 4.477-10 10-10zm80-80c5.523 0 10 4.477 10 10v30c0 5.523-4.477 10-10 10H30c-5.523 0-10-4.477-10-10v-30c0-5.523 4.477-10 10-10zm100-80c5.523 0 10 4.477 10 10v30c0 5.523-4.477 10-10 10H30c-5.523 0-10-4.477-10-10V50c0-5.523 4.477-10 10-10z"
})));
export default SvgSortDescending;